import { isEqual } from "@resamare/functions";
import { useMutationObserver } from "@resamare/react-hooks";
import { useCallback, useEffect, useRef } from "react";

export function useMonthsChange(
    headerRef?: React.RefObject<HTMLElement>,
    onChange?: (months: string[]) => void,
    deps: unknown[] = [],
) {
    const lastMonths = useRef<string[]>([]);

    const handleMonthsChange = useCallback(() => {
        const calendar = headerRef?.current?.closest(".react-datepicker");
        const months = Array.from(calendar?.querySelectorAll("[data-month]") || [])
            .map((month) => month.getAttribute("data-month"))
            .filter(Boolean) as string[];

        if (!isEqual(lastMonths.current, months)) {
            lastMonths.current = months;
            onChange?.(months);
        }
    }, [headerRef, onChange]);

    useEffect(() => {
        if (onChange) {
            handleMonthsChange();
        }
    }, [handleMonthsChange, onChange, ...deps]);

    useMutationObserver(headerRef, onChange ? handleMonthsChange : undefined, {
        subtree: true,
        attributeFilter: ["data-month"],
    });
}
